import { Card, Row, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { emailer } from "../../../assets/images";
import { DAYS, MONTHS } from "../../../constants/companyMailer";

const MailerCard = ({ mailStep, sentTestMail, sendMailNowOrLater, edit_preview, mailerData, pageloading, stats, launched, activatedCount, onClone  }) => {
  
  const [groupedMailerData, setGroupedMailerData] = useState([]);
  
  useEffect(() => {
    if (mailerData?.length) {
      const grouped = structureMailerData(mailerData);
      setGroupedMailerData(grouped);
    }
  }, [mailerData]);

  const structureMailerData = (data) => {
    if (!Array.isArray(data)) return [];

    const variants = data.filter(m => m.is_variant);
    const replicas = data.filter(m => m.is_replica);

    return variants.map(variant => {
      const relatedReplicas = replicas.filter(rep => rep.company_mailer_id === variant.id);
      return [variant, ...relatedReplicas];
    });
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "draft":       // blue tone
        return { background: '#E5EEFF', color: '#4D6189' };
      case "scheduled":   // also blue tone
        return { background: '#E5EEFF', color: '#4D6189' };
      case "sent":        // green tone
        return { background: '#DBFBE9', color: '#00A04F' };
      default:            // gray fallback
        return { background: '#F1F5F9', color: '#64748B' }; // tailwind: bg-slate-100 text-slate-600
    }
  }


  const dateFormat = (val) => {
    if (!val) return '';

    const dateObj = new Date(val);
    const day = DAYS[dateObj.getDay()] || '';
    const date = dateObj.getDate().toString().padStart(2, '0');
    const month = MONTHS[dateObj.getMonth()] || '';
    const year = dateObj.getFullYear();
    const hours = dateObj.getHours().toString().padStart(2, '0');
    const minutes = dateObj.getMinutes().toString().padStart(2, '0');

    return `${day}, ${date} ${month} ${year} at ${hours}:${minutes}`;
  };

  const metrics = (data) => {
    if (!data) return null;

    const { count, sent, delivered_stats, open } = calculateStats(data);
    const items = [
      {
        show: data.delivery?.delivered,
        label: 'SENT',
        value: sent,
        suffix: 'Emails',
      },
      {
        show: data.delivery?.delivered,
        label: 'Delivered',
        value: delivered_stats,
        suffix: 'Emails',
      },
      {
        show: data.engagement?.open,
        label: 'Opened Rate',
        value: open,
        suffix: 'Opened',
      },
      {
        show: launched,
        label: 'Action',
        value: activatedCount,
        suffix: 'Activated',
      }
    ];

    return (
      <div className='font-semibold float-right flex flex-row'>
        {items.map(({ show, label, value, suffix }) =>
          show && (
            <div key={label} className='px-5 mx-4 text-center'>
              <div className='text-xs uppercase tracking-widest text-[#7C8CAB]'>{label}</div>
              <div className='text-xl text-[#0D1A35]'>{Math.trunc((value / count) * 100)}%</div>
              <div className='font-normal text-xs text-[#7C8CAB]'>{value} {suffix}</div>
            </div>
          )
        )}
      </div>
    );
  };

  const calculateStats = (data) => {
    const all = [data, ...(data.grade_variants || [])];
    let sent = 0, delivered = 0, open = 0, count = 0;

    all.forEach(({ mail_count = 0, delivery = {}, engagement = {} }) => {
      count += mail_count;
      sent += ['delivered', 'processed', 'bounce', 'deferred'].reduce((sum, key) => sum + (delivery[key] || 0), 0);
      delivered += (delivery.delivered || 0) + (delivery.processed || 0);
      open += (engagement.open || 0) + (engagement.click || 0);
    });

    return { count, sent, delivered_stats: delivered, open };
  };

  const renderMailerCard = (data) => (
    data.map((data, index) => {
      const { id, grade, subject, status, sent_at, updated_at, insights, content, schedule_time } = data;
      const gradeName = grade === 'base' ? 'Ungraded' : `Grade ${grade}`
      const isSent = status === "sent" && sent_at;
      const isScheduled = status === "scheduled" && schedule_time;
      const { background, color } = getStatusColor(status);
      const disabledSend = !content;
      return (
          <Card id={index} style={{ minHeight: 230, marginTop: 20 }} loading={pageloading} className='overview-card relative'>
          <Row className='font-semibold text-lg'>{gradeName}
              <span style={{background: background, color: color}} className='rounded-xl px-3 py-1 ml-2 font-semibold text-xs'>
                {status}
              </span>
          </Row>
          <Row style={{ fontWeight: 400, width: '70%', marginTop: 7}}>
              {gradeName} Replica is a follow-up communication sent after the official announcement, providing details on how to access the new benefit and outlining its key features.
          </Row>
          { !isSent &&
            <div className='absolute top-6 right-6'>
    
          <button
              name={`${grade}-${id}`}
              type='submit'
              onClick={mailStep}
              className='inline-flex right-8 items-center mx-4 px-4 py-3 text-base font-semibold rounded-md text-blue-700 hover:bg-blue-50 transition'
          >
              Edit mailer
          </button>
          <Tooltip
            placement='bottomLeft'
            overlayStyle={{maxWidth: '235px'}}
            color={'#0D1A35'}
            key='pink'
            title={`${disabledSend ? `Ensure the email content is saved before initiating the ${gradeName} mailer.` : ''}`}
            align
          >
            {!isScheduled &&
              <button name={`${grade}-${id}`} type='submit'
              disabled={disabledSend}
              className={`inline-flex right-8 items-center px-4 py-2 border-2 border-gray-200 text-base font-semibold rounded-md transition text-blue-700 focus:outline-none ${disabledSend ? 'cursor-not-allowed hover:bg-gray-100 hover:text-gray-600' : 'cursor-pointer hover:bg-blue-50'}`} 
              onClick={sendMailNowOrLater}>
                Send now
            </button>}
          </Tooltip>
          </div>}
          <Row style={{background: '#F5F8FF80'}} className='my-4 px-3 py-4 rounded border-2'>
              <div className='float-left flex flex-row'>
                <img src={emailer} alt='#' style={{height: 46, width: 48}}/>
                <div className='mx-2'>
                  <div className='font-semibold text-base' style={{color: '#0D1A35'}}>Subject : {subject}</div>
                  <div className=''><strong className='text-slate-800'>{isSent ? 'Sent' : (isScheduled ? 'Scheduled' : 'Draft')}</strong> {isScheduled ? 'for' :'on'} {isSent ? dateFormat(sent_at) : (isScheduled ? dateFormat(schedule_time) : dateFormat(updated_at))}</div>
                  { !isSent &&
                    <div className='flex items-center'>
                      <button name={`${grade}-${id}`} onClick={sentTestMail} disabled={disabledSend} className={`font-semibold ${disabledSend ? 'cursor-not-allowed text-gray-500' : 'cursor-pointer text-blue-600'} `}>Send Test Mail</button>
                      <div className="bg-zinc-300 rounded mx-2 w-1 h-1 font-semibold" style={{background: '#D9D9D9'}}></div>
                      <button name={`${grade}-${id}`} onClick={edit_preview} disabled={disabledSend} className={`font-semibold ${disabledSend ? 'cursor-not-allowed text-gray-500' : 'cursor-pointer text-blue-600'} `}>Preview</button>
                    </div>}
                </div>
              </div>
              {isSent && metrics(insights)}
          </Row>
        </Card>
      )
    }));


    return (
      <>
        {groupedMailerData.map((group, index) => {
          const variant = group[0]; // First item is always the variant
          const replicas = group.slice(1);
          const { id, grade } = variant || {};
          const gradeName = grade === 'base' ? 'Ungraded' : `Grade ${grade}`
  
          return (
            <Card
              key={id || index}
              style={{ minHeight: 150, marginTop: 20, background: '#FAFAFA' }}
              loading={pageloading}
              className='overview-card relative'
            >
              <div className=" flex justify-between items-center">
                <h4 className="inline-block px-3 py-1 text-sm font-semibold text-purple-700 bg-purple-50 border border-purple-200 rounded-full">
                  {gradeName} mailer
                </h4>
                <div className='justify-end flex mb-4'>
                  <button
                    name={`${grade}-${id}`}
                    type='submit'
                    className={`inline-flex items-center px-4 py-2 border-2 border-gray-200 bg-white text-base font-semibold rounded-md transition text-blue-700 focus:outline-none cursor-pointer hover:bg-blue-50`}
                    onClick={() => onClone(variant, gradeName)}
                  >
                    Clone mailer
                  </button>
                </div>
              </div>
  
              {/* Render Variant Mailer */}
              {renderMailerCard([variant])}
  
              {/* Render Replicas below */}
              {replicas.length > 0 && (
                <div className='mt-4'>
                  <h4 className="inline-block px-3 py-1 mt-4 ml-4 text-sm font-semibold text-blue-700 bg-blue-50 border border-blue-200 rounded-full">
                    Replicas
                  </h4>
                  {renderMailerCard(replicas)}
                </div>
              )}
            </Card>
          );
        })}
        </>
    );
  
}

export default MailerCard;
